/**
 * @file The ExchangeListComponent is used to create a exchange request.
 * The form is activated with an action button and displayed in the overlay.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NotificationsService } from '../notifications.service';
import { AlertsService } from '../../core/alerts.service';
import { OverlayService } from '../../core/overlay.service';
import { OverlayProvider } from '../../ui/overlay-provider';
import { FormControl, FormGroup } from '@angular/forms';
import { RequestTypes } from '../request-types';
import { RequestStatus } from '../request-status';
import * as moment from 'moment';
import { BackendSettingsService } from '../../backend-settings.service';
import { ListComponent } from '../../domain/list/list.component';
import { AbstractBase } from '../../core/helpers/abstract-base';
import { TranslateService } from '@ngx-translate/core';
/** Name of query parameter dynamically added to AgendaListComponent. */
var TARGET_LIST_RESOURCE_OID = 'resourceOid';
/**
 * The ExchangeListComponent is used to create a exchange request.
 * The form is activated with an action button and displayed in the overlay.
 * @export
 * @class ExchangeListComponent
 * @implements {OnInit}
 */
var ExchangeListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExchangeListComponent, _super);
    /**
     * Creates an instance of ExchangeListComponent.
     * @param {NotificationsService} notificationsService To communicate with the backend.
     * @param {AlertsService} alertsService  To show feedback messages to the user.
     * @param {OverlayService} overlayService The service that manages the overlay of the application.
     * @param {OverlayProvider} overlayProvider To provide the needed create parameters.
     */
    function ExchangeListComponent(notificationsService, alertsService, overlayService, backendSettingsService, overlayProvider, translateService) {
        var _this = _super.call(this) || this;
        _this.notificationsService = notificationsService;
        _this.alertsService = alertsService;
        _this.overlayService = overlayService;
        _this.backendSettingsService = backendSettingsService;
        _this.translateService = translateService;
        /**
         * Gets sets the field to hold the receiver entity.
         * @private
         * @type {Entity}
         */
        _this._receiver = null;
        /**
         * The date is used to search for a target.
         */
        _this._date = moment();
        /**
         * FormControl to bind with the InputDateComponent.
         * This is needed for the angular input validation mechanism.
         * The input provides the query date of the targetList.
         */
        _this.dateControl = new FormControl();
        /**
         * FormControl to bind with the InputEntityComponent.
         * This is needed for the angular input validation mechanism.
         * The input provides the query resource oid, representing the receiver of the request.
         */
        _this.resources = new FormControl();
        /**
         * FormGroup of the template.
         * This is needed for the angular input validation mechanism.
         */
        _this.form = new FormGroup({});
        _this.subjectTask = overlayProvider.entity;
        if (!_this.subjectTask) {
            throw Error('Exchange task missing in ExchangeListComponent.');
        }
        var config = overlayProvider.configuration;
        if (config.components && config.components.length !== 0) {
            _this.listConfiguration = config.components[0].configuration;
        }
        _this.formConfiguration = overlayProvider.configuration;
        if (_this.subjectTask.entityType.shortName === 'PlanItem') {
            _this.subjectTask = _this.subjectTask['Item'];
        }
        _this.form.addControl('resources', _this.resources);
        return _this;
    }
    Object.defineProperty(ExchangeListComponent.prototype, "receiver", {
        /**
         * Gets the receiver of the exchange request.
         * @type {Entity}
         */
        get: function () {
            return this._receiver;
        },
        /**
         * Sets the receiver of the exchange request.
         * @type {Entity}
         */
        set: function (value) {
            if (this._receiver === value) {
                return;
            }
            this._receiver = value;
            var receiverOid = '?';
            if (value) {
                receiverOid = value['Oid'];
            }
            if (this.targetList) {
                this.targetList.current = null;
                this.targetList[TARGET_LIST_RESOURCE_OID] = receiverOid;
                // this.targetList.level = detailLevelDay;
                this.targetList.refresh();
            }
            if (this.request) {
                this.request.Title = this.translateService.instant('APP.NOTIFICATIONS.TYPE_EXCHANGE') + " " + this.subjectTask['Name'];
                this.request.TargetOid = '';
                this.request.ReceiverOid = receiverOid;
                var same = this.request;
                this.request = null;
                this.request = same;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExchangeListComponent.prototype, "entityOid", {
        get: function () {
            return this.subjectTask['Oid'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExchangeListComponent.prototype, "date", {
        /**
         * Gets the date.
         */
        get: function () {
            return this._date.toDate();
        },
        /**
         * Sets the date and fires dateChanged method if it is different.
         */
        set: function (value) {
            var date = moment(value);
            if (!date.isSame(this._date)) {
                this._date = date;
                this.dateChanged();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExchangeListComponent.prototype, "requestId", {
        /**
         * Gets the Id of the current request.
         * @readonly
         * @type {number}
         */
        get: function () {
            if (!this.request) {
                return -1;
            }
            // Breeze.js find het niet leuk als je Id defined.
            // Maar ik heb hem nodig in template en dat find AOT weer niet leuk :(
            return this.request['Id'];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Lifecycle hook that is called after data-bound properties are initialized.
     * The exchange request is created and its properties are initialized.
     */
    ExchangeListComponent.prototype.ngOnInit = function () {
        this.request = this.notificationsService.getEntityType('Request').createEntity();
        if (this.subjectTask.entityType.shortName === 'Assignment') {
            this.request.Type = RequestTypes.ExchangeAssignment;
        }
        else if (this.subjectTask.entityType.shortName === 'Attendant') {
            this.request.Type = RequestTypes.ExchangeAttendant;
        }
        else {
            this.alertsService.createAlert('danger', 'Unknown subject type: ' + this.subjectTask.entityType.shortName);
        }
        this.request.Status = RequestStatus.Request;
        this.request.Title = this.translateService.instant('APP.NOTIFICATIONS.TYPE_EXCHANGE') + " " + this.subjectTask['Name'];
        this.request.SubjectOid = this.subjectTask['Oid'];
        this.request.SenderOid = this.subjectTask['Resource_Oid']; // Of moet dit configurationsService.user.resourceOid zijn?
        this.notificationsService.addEntity(this.request);
        // targetList must be there.
        this.targetList[TARGET_LIST_RESOURCE_OID] = '?';
        this.targetList['entityOid'] = this.subjectTask['Oid'];
        this.targetList['senderOid'] = this.subjectTask['Resource_Oid'];
        this.date = moment().add(this.backendSettingsService.daysBeforeExpiration, 'days').toDate();
    };
    /**
     * This method is invoked when the user selects a task from the targetList.
     * The selected task is used as target task of the exchange request.
     * @param {Entity} entity The selected task.
     */
    ExchangeListComponent.prototype.onTargetChanged = function (entity) {
        var targetTask = entity;
        if (targetTask) {
            if (targetTask.entityType.shortName === 'PlanItem') {
                targetTask = targetTask['Item'];
            }
            this.request.Title = this.translateService.instant('APP.NOTIFICATIONS.TYPE_EXCHANGE') + " " + this.subjectTask['Name'] + " ";
            this.request.Title += this.translateService.instant('APP.NOTIFICATIONS.FOR') + " " + targetTask['Name'];
            this.request.TargetOid = targetTask['Oid'];
            this.request.ReceiverOid = targetTask['Resource_Oid'];
        }
    };
    /**
     * This method is invoked when the selected date changes.
     */
    ExchangeListComponent.prototype.dateChanged = function () {
        // The list has no selected item.
        this.targetList.current = null;
        // The request title contains only the subject task.
        this.request.Title = this.subjectTask['Name'];
        // Receiver and target are adjusted.
        if (!this.receiver) {
            this.request.ReceiverOid = null;
        }
        this.request.TargetOid = null;
        // Set query parameters and refresh the target list.
        this.targetList['start'] = this._date.clone().startOf('day');
        this.targetList['finish'] = this._date.clone().endOf('day');
        this.targetList.refresh();
    };
    /**
     * Returns a value indicating whether the request is ready to be saved.
     */
    ExchangeListComponent.prototype.canSave = function () {
        return this.targetList && this.targetList.current;
    };
    /**
     * Cancels the request and closes the overlay.
     */
    ExchangeListComponent.prototype.cancelItem = function () {
        this.request.entityAspect.rejectChanges();
        this.overlayService.closeOverlay();
    };
    /**
     * Saves the new created exchange request when valid.
     * @param {any} event The click event that triggered the method.
     * @returns void
     */
    ExchangeListComponent.prototype.saveItem = function (event) {
        if (!this.canSave()) {
            return; // Request is nog niet compleet.
        }
        if (!this.backendSettingsService.isOnTime(this.subjectTask, this.targetList.current)) {
            this.alertsService.createAlert('warning', 'APP.NOTIFICATIONS.TOO_LATE');
            return;
        }
        var self = this;
        if (event) {
            event.target.classList.add('sym-working');
        }
        this.notificationsService.symptomManagementIssue1319();
        this.notificationsService.saveChanges(function (error) {
            // Remove sym-working to show that action is finished.
            if (event) {
                event.target.classList.remove('sym-working');
            }
            // Give correct alert based on whether an error is given or not.
            if (error) {
                self.alertsService.createAlert('warning', 'APP.NOTIFICATIONS.REQUEST_UNSUCCESSFULLY_SENT');
            }
            else {
                self.alertsService.createAlert('success', 'APP.NOTIFICATIONS.REQUEST_SUCCESSFULLY_SENT');
                self.overlayService.closeOverlay();
            }
        });
    };
    return ExchangeListComponent;
}(AbstractBase));
export { ExchangeListComponent };
